import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent {
  @Input() confirmationContent: any = {
    action: '',
    title: 'Are you sure!',
    content: 'Are you sure you want to perform this action?',
    submitBtnText: 'Yes',
    cancelBtnText: 'No',
    hideSubmitButton: false,
    hideCancelButton: false
  };
  @Output() onSubmit = new EventEmitter<any>();
  constructor(private modalService: NgbModal) {}

  ngOnInit() {}

  cancelModal() {
    this.modalService.dismissAll();
  }

  onSubmitBtnClick() {
    this.onSubmit.emit(this.confirmationContent.action);
    this.cancelModal();
  }
}
